// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useState } from "react";

import { Box, IconButton, styled, Typography } from "@3778.care/goban";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import PropTypes from "prop-types";

import { useMixpanel } from "../../../../contexts/mixpanel";
import { useIsDesktop } from "../../../../util/useIsDesktop";
import { Snackbar } from "../Snackbar";

const StyledTypography = styled(Typography)(
  ({ theme: { palette, spacing } }) => ({
    color: palette.grey["600"],
    paddingLeft: spacing(1),
  })
);
const StyledIcon = styled(IconButton)(({ theme: { spacing } }) => ({
  padding: spacing(1),
}));

export const AppointmentLocation = ({ location }) => {
  const [open, setSnackbarOpen] = useState(false);
  const isDesktop = useIsDesktop();
  const { track } = useMixpanel();

  const copyToClipboard = (text) => {
    setSnackbarOpen(true);
    navigator.clipboard.writeText(text);
  };

  const handleClose = (_, reason) =>
    reason === "clickaway" ? undefined : setSnackbarOpen(false);

  const handleClick = () => {
    track("Appointment - Copy location");
    return copyToClipboard(location);
  };

  return (
    <Box display="flex" alignItems="center" paddingTop={2}>
      <StyledTypography variant={isDesktop ? "body1" : "caption"}>
        {location}
      </StyledTypography>

      <StyledIcon color="primary" onClick={handleClick}>
        <FileCopyOutlinedIcon />
      </StyledIcon>

      <Snackbar
        handleClose={handleClose}
        message="Endereço copiado com sucesso!"
        open={open}
      />
    </Box>
  );
};

AppointmentLocation.propTypes = {
  location: PropTypes.string.isRequired,
};
